<div>
  <app-vct-up-to-filters *ngIf="years"
                         [years]="years"
                         (search)="searchData($event)">
  </app-vct-up-to-filters>
  <mat-divider></mat-divider>
  <app-vct-up-to-bar-chart
    [title]="text"
    [subtitle]="subtitle"
    [displayUnits]="displayUnits"
    [data]="data">
  </app-vct-up-to-bar-chart>
</div>
